import IconifyIcon from './components/IconifyIcon'

export default IconifyIcon
